import React from "react";
import FaqPanel from "./FaqPanel";
import FaqTabs from "./FaqTabs";

function FAQ() {
	return (
		<div className="app">
			<h2 style={{ textAlign: "center" }}>FAQ's</h2>
			<FaqTabs>
				<FaqPanel title="How do I know which coding language is best for me?">
					<p>
						The most efficient way to choose a language for you is
						to look at what suits your best interest. For example,
						Python is mostly recommended for Machine Learning, Deep
						Learning, Data Science. Whereas, you can choose C,Java
						for software building, Full-stack development etc. The
						efficiency to building a strong core-concept is moslty
						handed out by C++ in the competitive programming aspect.
						As far as what will be in demand in the future—really,
						all tech careers will be. But in particular, those
						relating to data science, AI, and cybersecurity will
						have a notable labor shortage in years to come, so if
						you have an interest in any of those, definitely go for
						it.
					</p>
					<p>
						If you want to find out more about the various career
						paths available, head over and listen to the MasterClass
						videos on our youtube link and sign up for more updates!{" "}
					</p>
				</FaqPanel>
				<FaqPanel title="How are my queries resolved during a course?">
					The most efficient way to choose a language for you is to
					look at what suits your best interest. For example, Python
					is mostly recommended for Machine Learning, Deep Learning,
					Data Science. Whereas, you can choose C,Java for software
					building, Full-stack development etc. The efficiency to
					building a strong core-concept is moslty handed out by C++
					in the competitive programming aspect. As far as what will
					be in demand in the future—really, all tech careers will be.
					But in particular, those relating to data science, AI, and
					cybersecurity will have a notable labor shortage in years to
					come, so if you have an interest in any of those, definitely
					go for it. If you want to find out more about the various
					career paths available, head over and listen to the
					MasterClass videos on our youtube link and sign up for more
					updates!
				</FaqPanel>
				<FaqPanel title="What if I am not satisfied with the course?">
					<p>
						The most efficient way to choose a language for you is
						to look at what suits your best interest. For example,
						Python is mostly recommended for Machine Learning, Deep
						Learning, Data Science. Whereas, you can choose C,Java
						for software building, Full-stack development etc. The
						efficiency to building a strong core-concept is moslty
						handed out by C++ in the competitive programming aspect.
						As far as what will be in demand in the future—really,
						all tech careers will be. But in particular, those
						relating to data science, AI, and cybersecurity will
						have a notable labor shortage in years to come, so if
						you have an interest in any of those, definitely go for
						it.
					</p>
					<p>
						If you want to find out more about the various career
						paths available, head over and listen to the MasterClass
						videos on our youtube link and sign up for more
						updatesss!{" "}
					</p>
				</FaqPanel>
				<FaqPanel title="What is the fastest way to learn coding?">
					<p>
						The most efficient way to choose a language for you is
						to look at what suits your best interest. For example,
						Python is mostly recommended for Machine Learning, Deep
						Learning, Data Science. Whereas, you can choose C,Java
						for software building, Full-stack development etc. The
						efficiency to building a strong core-concept is moslty
						handed out by C++ in the competitive programming aspect.
						As far as what will be in demand in the future—really,
						all tech careers will be. But in particular, those
						relating to data science, AI, and cybersecurity will
						have a notable labor shortage in years to come, so if
						you have an interest in any of those, definitely go for
						it.
					</p>
					<p>
						If you want to find out more about the various career
						paths available, head over and listen to the MasterClass
						videos on our youtube link and sign up for more
						updatesss!{" "}
					</p>
				</FaqPanel>
				<FaqPanel title="Do I need any Prior experience/ Knowledge?">
					<p>
						The most efficient way to choose a language for you is
						to look at what suits your best interest. For example,
						Python is mostly recommended for Machine Learning, Deep
						Learning, Data Science. Whereas, you can choose C,Java
						for software building, Full-stack development etc. The
						efficiency to building a strong core-concept is moslty
						handed out by C++ in the competitive programming aspect.
						As far as what will be in demand in the future—really,
						all tech careers will be. But in particular, those
						relating to data science, AI, and cybersecurity will
						have a notable labor shortage in years to come, so if
						you have an interest in any of those, definitely go for
						it.
					</p>
					<p>
						If you want to find out more about the various career
						paths available, head over and listen to the MasterClass
						videos on our youtube link and sign up for more
						updatesss!{" "}
					</p>
				</FaqPanel>
			</FaqTabs>
			<br />
			{/* <h1>FaqAccordion Demo</h1>
      <h2>Default</h2>
      <FaqAccordion>
        <div label="Alligator Mississippiensis">
          <p>
            <strong>Common Name:</strong> American Alligator
          </p>
          <p>
            <strong>Distribution:</strong> Texas to North Carolina, United
            States
          </p>
          <p>
            <strong>Endangered Status:</strong> Currently Not Endangered
          </p>
        </div>
        <div label="Alligator Sinensis">
          <p>
            <strong>Common Name:</strong> Chinese Alligator
          </p>
          <p>
            <strong>Distribution:</strong> Eastern China
          </p>
          <p>
            <strong>Endangered Status:</strong> Critically Endangered
          </p>
        </div>
      </FaqAccordion>
      <h2>Allow Multiple Open + Open Section By Default</h2>
      <FaqAccordion allowMultipleOpen>
        <div label="Alligator Mississippiensis" isOpen>
          <p>
            <strong>Common Name:</strong> American Alligator
          </p>
          <p>
            <strong>Distribution:</strong> Texas to North Carolina, United
            States
          </p>
          <p>
            <strong>Endangered Status:</strong> Currently Not Endangered
          </p>
        </div>
        <div label="Alligator Sinensis">
          <p>
            <strong>Common Name:</strong> Chinese Alligator
          </p>
          <p>
            <strong>Distribution:</strong> Eastern China
          </p>
          <p>
            <strong>Endangered Status:</strong> Critically Endangered
          </p>
        </div>
      </FaqAccordion> */}
		</div>
	);
}

export default FAQ;
